import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/samsung/smart-things/(app)/ask-a-vet/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate to="/samsung/smart-things/ask-a-vet/agreement" replace />
}
